import {z} from 'zod';

export const ChatSettingsFormSchema = z.object({
  conversationSessionTimeoutHours: z.number().min(1),
  welcomeMessageTemplateId: z.string().nullable(),
});

export type ChatSettingsFormSchemaType = z.infer<typeof ChatSettingsFormSchema>;
